import React, { FC } from 'react';
import ButtonCmp from 'src/components/ButtonCmp';

interface IStepperAction {
    handleBack?: () => void;
    handleNext: () => void;
    backButtonText?: string;
    nextButtonText?: string;
    isNextButtonDisabled?: boolean;
    isNextButtonLoading?: boolean;
}

const StepperAction: FC<IStepperAction> = ({ handleBack, handleNext, backButtonText = 'Back', nextButtonText = 'Next', isNextButtonDisabled = false, isNextButtonLoading = false }) => (
    <div className="bg-white">
        <div className="stepper-content-container justify-between">
            <div className="flex gap-x-2">
                {handleBack && (
                    <ButtonCmp type="button" className="btn_secondary_black" onClick={handleBack}>
                        {backButtonText}
                    </ButtonCmp>
                )}
                <ButtonCmp type="button" className="btn-outline-primary" onClick={handleNext} disabled={isNextButtonDisabled || isNextButtonLoading} loading={isNextButtonLoading}>
                    {nextButtonText}
                </ButtonCmp>
            </div>
        </div>
    </div>
);

export default StepperAction;
